import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PFieldAbstractComponent } from '../p-field-abstract';
import { IconName } from '@panaya/ui/p-icon';
import { ColorName } from '@panaya/ui/styles-to-code';

@Component({
    selector: 'p-field-label',
    template: `
        <p-field
            [isMandatory]="isMandatory"
            [label]="label"
            [labelTooltip]="labelTooltip"
            [isReadOnly]="true"
            [customClasses]="customClasses"
            [shouldTransformLabelTextCase]="shouldTransformLabelTextCase"
            [ngClass]="{ alignTop: isMultiline }"
            [preLabelIcon]="preLabelIcon"
            [preLabelIconColor]="preLabelIconColor"
        >
            <input
                *ngIf="!isMultiline && !labelOnly"
                readonly
                slot="readMode"
                [value]="value"
                class="ellipsis"
                [matTooltip]="value ?? ''"
                [matTooltipDisabled]="hideToolTip"
                [attr.automation-id]="'p-field-label_' + label"
            />

            <p class="multiline-content p-paragraph-1" *ngIf="isMultiline && !labelOnly" slot="readMode">{{ value }}</p>
        </p-field>
    `,
    styleUrls: ['./p-field-label.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldLabelComponent
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PFieldLabelComponent extends PFieldAbstractComponent<string> {
    @Input() label?: string;

    @Input() isMandatory = false;
    @Input() labelOnly = false;
    /*@Input() textCustomClass: string;*/
    @Input() isFitTextWidth = false;
    @Input() isInEditMode = false;
    @Input() customClasses?: string;
    @Input() isMultiline = false;
    @Input() hideToolTip = false;
    @Input() preLabelIcon?: IconName;
    @Input() preLabelIconColor!: ColorName;

    get classes(): object {
        return {
            textCustomClass: true,
            'label-width-auto': this.isFitTextWidth
        };
    }

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }
}
